import { useMemo, useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

const WEEKDAYS = ["Pzt", "Sal", "Çar", "Per", "Cum", "Cmt", "Paz"];

export default function Calendar({ value, onChange }) {
  const today = useMemo(() => {
    const d = new Date();
    d.setHours(0, 0, 0, 0);
    return d;
  }, []);
  const [view, setView] = useState(() => new Date(today.getFullYear(), today.getMonth(), 1));

  const y = view.getFullYear();
  const m = view.getMonth();
  const firstOffset = (new Date(y, m, 1).getDay() + 6) % 7;
  const daysInMonth = new Date(y, m + 1, 0).getDate();
  const monthLabel = view.toLocaleDateString("tr-TR", { month: "long", year: "numeric" });
  const minView = new Date(today.getFullYear(), today.getMonth(), 1);
  const maxView = new Date(today.getFullYear(), today.getMonth() + 5, 1);

  const cells = [];
  for (let i = 0; i < firstOffset; i++) cells.push(null);
  for (let d = 1; d <= daysInMonth; d++) cells.push(new Date(y, m, d));

  return (
    <div className="cal" data-testid="booking-calendar">
      <div className="cal-head">
        <button type="button" onClick={() => setView(new Date(y, m - 1, 1))} disabled={view <= minView} aria-label="Önceki ay" data-testid="cal-prev-month">
          <ChevronLeft size={18} />
        </button>
        <strong data-testid="cal-month-label">{monthLabel}</strong>
        <button type="button" onClick={() => setView(new Date(y, m + 1, 1))} disabled={view >= maxView} aria-label="Sonraki ay" data-testid="cal-next-month">
          <ChevronRight size={18} />
        </button>
      </div>
      <div className="cal-week">
        {WEEKDAYS.map((w) => <span key={w}>{w}</span>)}
      </div>
      <div className="cal-grid">
        {cells.map((date, i) =>
          date === null ? (
            <span key={`empty-${i}`} />
          ) : (
            <button
              type="button"
              key={date.toISOString()}
              className={`cal-day${value && date.toDateString() === value.toDateString() ? " selected" : ""}`}
              disabled={date < today}
              onClick={() => onChange(date)}
              data-testid={`cal-day-${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`}
            >
              {date.getDate()}
            </button>
          ),
        )}
      </div>
    </div>
  );
}
